/*
 *   File : rebalance-history.js
 *   Author : https://evoqins.com
 *   Description : rebalance history component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { useEffect } from "react";
import { DataTableComponent } from "../../../Components/DataTable";
import { useDispatch } from "react-redux";
import {
  setNavLink,
  setPageTitle,
  setSearchEnabled,
} from "../../../Redux/Ui/ui.slice";
import { APIService } from "../../../Service";
import { useParams } from "react-router-dom";
const COLUMNS = [
  {
    name: "Date",
    selector: (row) => row.date,

    width: "160px",
  },
  {
    name: "Triggered By",
    selector: (row) => row.triggeredBy,

    wrap: true,
  },
  {
    name: "Impacted Users",
    selector: (row) => row.impactedUsers,
  },
  {
    name: "Changes",
    selector: (row) => row.changes,
    sortable: false,
    wrap: true,
  },
];

const DATA = [
  {
    id: 1,
    date: "12 Aug 2025",
    triggeredBy: "System Auto-Rebalance",
    impactedUsers: "542 Users",
    changes:
      "Added fund: Nippon India Large Cap Fund, allocation 10%. Changed allocation: Bandhan Infrastructure Growth plan 30% to 10%.",
  },
  {
    id: 2,
    date: "10 Aug 2025",
    triggeredBy: "Admin – Rahul Mehta",
    impactedUsers: "89 Users",
    changes:
      "Added fund: ICICI Bluechip Fund, allocation 5%. Changed allocation: Axis Small Cap Fund 15% to 20%.",
  },
  {
    id: 3,
    date: "08 Aug 2025",
    triggeredBy: "System Auto-Rebalance",
    impactedUsers: "321 Users",
    changes:
      "Removed fund: SBI Midcap Fund. Changed allocation: Kotak Emerging Equity 25% to 18%.",
  },
  {
    id: 4,
    date: "05 Aug 2025",
    triggeredBy: "Admin – Neha Sharma",
    impactedUsers: "120 Users",
    changes:
      "Added fund: Axis ELSS Tax Saver, allocation 7%. Changed allocation: HDFC Top 100 Fund 20% to 15%.",
  },
  {
    id: 5,
    date: "02 Aug 2025",
    triggeredBy: "System Auto-Rebalance",
    impactedUsers: "254 Users",
    changes:
      "Changed allocation: ICICI Value Discovery 18% to 22%. Removed fund: UTI Nifty Index Fund.",
  },
];

export default function BasketRebalanceHistory() {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    _fetchBasketDetail();
  }, []);

  const _fetchBasketDetail = async () => {
    try {
      const res = await APIService(true, "manage-basket/view-detail", {
        basket_style_id: parseInt(id),
      });

      if (res.status_code === 200 && res.data) {
        const data = res.data;
        dispatch(
          setPageTitle(["Manage Basket", `${data.name}`, "Rebalance History"]),
        );
        dispatch(setSearchEnabled(false));
        dispatch(setNavLink(["/manage-basket", `/manage-basket/detail/${id}`]));
      }
    } catch (err) {
      console.error("basket/detail error:", err);
    }
  };
  return (
    <div className="d-flex flex-column pt-24">
      <div className=" e-glass-card d-flex rounded-16 flex-column">
        <h3 className="fw-500 fs-18 lh-20 text-eerie-black mb-0 p-24">
          Rebalance History
        </h3>
        {/* PAGINATED TABLE */}
        <div className="d-flex">
          <DataTableComponent
            info={false}
            columns={COLUMNS}
            data={DATA}
            className="e-table-basic"
          />
        </div>
      </div>
    </div>
  );
}
